import { Box, IconButton, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import { useRef } from 'react';
import { TableWarningButton } from '../../../components/style/ButtonStyle';
import { ImageIcon } from '../../../layouts/dashboard/nav/IconButton';

export default function MarkerImageInput({ form }: any) {
  const fileInputRef = useRef<any>();
  function onSelect(e: any) {
    e.preventDefault();
    const img = e.target.files[0];
    if (!!img) {
      const reader = new FileReader();
      reader.readAsDataURL(img);

      reader.onload = function () {
        const imgUrl = reader.result;
        form.setValue('imageUrl', imgUrl);
      };
      form.setValue('file', img);
    }
  }
  const image = form.watch('file');
  const imageUrl = form.watch('imageUrl');
  const iconUrl = form.watch('iconUrl');

  return (
    <>
      {_.isEmpty(imageUrl) && _.isEmpty(iconUrl) ? (
        <>
          <IconButton
            onClick={() => {
              fileInputRef.current.click();
            }}
            sx={{
              background: '#F8F8F8',
              borderRadius: '8px',
              p: 3,
              width: 'fit-content',
            }}
          >
            <ImageIcon />
          </IconButton>
          <Typography
            sx={{
              ml: '14px',
              mt: '8px',
              color: '#DB2828',
              fontSize: '0.75rem',
            }}
          >
            마커 이미지를 선택해주세요.
          </Typography>
        </>
      ) : (
        <Stack spacing={1} direction="row" alignItems="flex-end">
          <Box
            component="img"
            alt={!!image ? image?.name : '마커 이미지'}
            src={_.isEmpty(imageUrl) ? iconUrl : imageUrl}
            sx={{ width: '100px', height: '100px', borderRadius: '8px' }}
          />

          <TableWarningButton
            onClick={() => {
              form.setValue('file', null);
              form.setValue('imageUrl', null);
              form.setValue('iconUrl', null);
            }}
            sx={{ height: 36 }}
          >
            삭제
          </TableWarningButton>
        </Stack>
      )}

      <input
        style={{ display: 'none' }}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        ref={fileInputRef}
        onChange={onSelect}
        multiple={false}
      />
    </>
  );
}
